<template>
  <!-- 活动管理 -->
  <div class="activityListbox">
    <div class="activityManage" v-loading="loading">
      <div class="backBox" style="height:46px;">
        <img class="pointer" src="@/assets/thdImg/pages/back.svg" alt="" @click='goBack' />
        <span class="backBox_name">{{dataForm.type==1?'0元入会小部件':'1分钱入会小部件'}}</span>
      </div>
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="step">
          <el-step title="未入会页面设置"></el-step>
          <el-step title="设置入会后卡面"></el-step>
          <el-step title="投放"></el-step>
        </el-steps>
      </div>
      <main class="main" style="display: flex;">
        <div class="main-left">
          <!-- 图片 -->
          <div v-if='step === 0' >
            <img style="width:270px;height:580px;" src="@/assets/images/liveCard/未入会预览图@2x.png" alt="">
            <img class="customImg" :src="imageUrl1" v-show='picType1==1&&imageUrl1' alt="">
          </div>
          <div v-else>
            <img style="width:270px;height:580px;" src="@/assets/images/liveCard/入会后预览图@2x.png" alt="">
            <img class="customImg" :src="imageUrl2" v-show='picType2==1&&imageUrl2' alt="">
          </div>
        </div>
        <div class="main-right">
          <!-- 第一步 -->
          <div v-if="step === 0">
            <div class="minTitle m-b-20">未入会卡面：</div>
            <div class="m-b-20" v-if='dataForm.type == 1'>
              <el-radio v-model="picType1" :label="0">系统预设</el-radio>
              <el-radio v-model="picType1" :label="1">自定义</el-radio>
            </div>
            <div class="m-b-24" v-show='picType1 == 0'>
              <img src="@/assets/images/liveCard/未入会-卡面系统预设@2x.png" class="avatar">
            </div>
            <div v-show='picType1 == 1'>
              <div class="imgUpload m-b-20">
                <el-upload
                  class="avatar-uploader"
                  action=""
                  multiple
                  :limit="1"
                  :before-upload="beforeUpload1"
                  accept=".jpg,.png">
                  <img v-if="imageUrl1" :src="imageUrl1" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div style="color:#999999">
                  <p class="my-mg-10">建议上传尺寸：714px*230px</p>
                  <p class="my-mg-10">图片大小：2MB以内</p>
                  <p class="my-mg-10">格式：jpg、png</p>
                </div>
              </div>
            </div>
            <div v-if='dataForm.type == 2'>
              <div class="minTitle m-b-20">设置1分钱商品：</div>
              <div class="item-box m-b-20">商品ID：<el-input class="ipt" v-model="dataForm.oneCentItems" placeholder="请输入"></el-input></div>
            </div>
            <div v-else>
              <div class="minTitle m-b-20">设置入会权益</div>
              <div class="item-box">
                <div class="m-b-20">
                  <label class="item-label" style="width:160px">入会后自动发放优惠券：</label>
                  <el-switch v-model="dataForm.configTextList[0].enable" :active-value="1" :inactive-value="0"></el-switch>
                </div>
                <div class="m-b-20">
                  <label class="item-label">优惠券面额：</label>
                  <el-input class="ipt" v-model="dataForm.configTextList[0].denomination" placeholder="请输入"></el-input>
                </div>
                <div class="m-b-20">
                  <label class="item-label">使用门槛：</label>
                  <el-input class="ipt" v-model="dataForm.configTextList[0].useThreshold" type="number" @input="dataForm.configTextList[0].noThreshold=false" placeholder="请输入"></el-input>
                  <el-checkbox class="m-l-10" v-model="dataForm.configTextList[0].noThreshold" @change="dataForm.configTextList[0].useThreshold=0">无门槛</el-checkbox>
                </div>
                <div class="m-b-20">
                  <label class="item-label">优惠券uuid：</label>
                  <el-select class="coupon_type" v-model="dataForm.configTextList[0].couponType" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-input class="ipt" v-model="dataForm.configTextList[0].uuid" placeholder="请输入"></el-input>
                   <span class="m-l-10" style="color:#999999;cursor: pointer;" @click='toDiscount'>
                    <!-- <el-tooltip class="item" effect="dark" content="领取" placement="top-start">
                      <i class="el-icon-question getuuid"></i>
                    </el-tooltip> -->
                    如何领取优惠券uuid
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- 第二步 -->
          <div v-else>
            <div class="minTitle m-b-20">设置已入会卡面背景：</div>
            <div class="m-b-20">
              <el-radio v-model="picType2" :label="0">系统预设</el-radio>
              <el-radio v-model="picType2" :label="1">自定义</el-radio>
            </div>
            <div class="m-b-24" v-show='picType2 == 0'>
              <img src="@/assets/images/liveCard/入会后-卡面系统预设@2x.png" class="avatar">
            </div>
            <div v-show='picType2 == 1'>
                <div class="imgUpload m-b-20">
                  <el-upload
                    class="avatar-uploader"
                    action=""
                    multiple
                    :limit="1"
                    :before-upload="beforeUpload1"
                    accept=".jpg,.png">
                    <img v-if="imageUrl2" :src="imageUrl2" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <div style="color:#999999">
                    <p class="my-mg-10">建议上传尺寸：714px*230px</p>
                    <p class="my-mg-10">图片大小：2MB以内</p>
                    <p class="my-mg-10">格式：jpg、png</p>
                  </div>
                </div>
            </div>
            <div class="minTitle m-b-20">设置优惠券权益：</div>
            <div class="item-box m-b-20" v-for="(item,index) in dataForm.configTextList" :key="index">
              <div class="m-b-20">
                <label class="item-label">优惠券{{index+1}}：</label>
                <el-switch v-model="item.enable" :active-value="1" :inactive-value="0"></el-switch>
              </div>
              <div v-show="item.enable">
                <div class="m-b-20">
                  <label class="item-label">优惠券面额：</label>
                  <el-input class="ipt" type="number" v-model="item.denomination" placeholder="请输入"></el-input>
                </div>
                <div class="m-b-20">
                  <label class="item-label">使用门槛：</label>
                  <el-input class="ipt" v-model="item.useThreshold" type="number" @input="item.noThreshold=false" placeholder="请输入"></el-input>
                  <el-checkbox class="m-l-10" v-model="item.noThreshold" @change="item.useThreshold = 0">无门槛</el-checkbox>
                </div>
                <div class="m-b-20">
                  <label class="item-label">领取门槛：</label>
                  <el-select class="ipt" v-model="item.getThreshold" placeholder="请选择">
                    <el-option label="不限制" :value="0"></el-option>
                    <el-option label="会员等级" :value="1"></el-option>
                  </el-select>
                  <el-checkbox-group class="m-l-10 m-t-10" style="display:inline-block;" v-model="item.levelIds">
                    <el-checkbox v-for="it in levelList" v-show='it.gradeStatus==1' :key="it.customerLevel" :label="String(it.customerLevel)" :disabled="item.getThreshold===0">{{it.customerLevelName}}</el-checkbox>
                  </el-checkbox-group>
                </div>
                <div>
                  <label class="item-label">优惠券uuid：</label>
                  <el-select class="coupon_type" v-model="item.couponType" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-input class="ipt" v-model="item.uuid" placeholder="请输入"></el-input>
                  <span class="m-l-10" style="color:#999999;cursor: pointer;" @click='toDiscount'>
                    <!-- <el-tooltip class="item" effect="dark" content="领取" placement="top-start">
                      <i class="el-icon-question getuuid"></i>
                    </el-tooltip> -->
                    如何领取优惠券uuid
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main> 
      <footer class="bottom-btnBox" v-if="step === 0">
        <el-button type="primary" plain @click='goBack'>返回</el-button>
        <el-button style="width:auto;" type="primary" @click="save">下一步：设置入会后样式</el-button>
      </footer>
      <footer class="bottom-btnBox" v-else>
        <el-button type="primary" plain style="width:auto;" @click="step=0;getList()">返回上一步</el-button>
        <el-button style="width:auto;" type="primary" @click="save">下一步：投放</el-button>
      </footer>
    </div>
  </div>
</template>

<script>
import { uploadImage } from "@/api/sellerImageController";
import { getMember } from "@/api/thd";
import { liveCardSave,getLiveCard } from "@/api/liveCard/liveCard";
export default {
  components: {

  },
  data() {
    return {
      options: [
        {
          value: 1,
          label: '通用优惠券'
        }, {
          value: 2,
          label: '会员专享券'
        }, {
          value: 3,
          label: '新会员礼包'
        },
      ],
      loading: true,
      step: 0, //  0-入会前 1-入会后
      imageUrl1: '',
      imageUrl2: '',
      levelList: [], // 会员等级
      picType1: 0, // 是否预设 0-系统预设 1-自定义
      picType2: 0, // 是否预设 0-系统预设 1-自定义
      dataForm: {
        oneCentItems: '', // 1分钱商品id
        picUrl: '', // 小部件长方形图片-url
        venderId: this.$store.state.loginUserInfo.sellerId, // 商家ID
        type: 1, // 小部件类型 1-0元入会招募 2-1分钱入会招募
        configTextList: [
          {
            index:1,
            enable: 0,
            levelIds: [],
            noThreshold: false,
            useThreshold: 0,
            denomination:'',
            getThreshold: 0,
          },
          {
            index:2,
            enable: 0,
            levelIds: [],
            noThreshold: false,
            useThreshold: 0,
            denomination:'',
            getThreshold: 0,
          },
          {
            index:3,
            enable: 0,
            levelIds: [],
            noThreshold: false,
            useThreshold: 0,
            denomination:'',
            getThreshold: 0,
          },
        ]
      },
      
    };
  },

  mounted() {
    this.dataForm.type = this.$route.query.type?this.$route.query.type:1

    getMember().then(res=>{ // 获取会员等级
      this.levelList = res.data
    })

    this.getList()
  },

  methods: {
    // 如何领取优惠券
    toDiscount() {
      window.open('https://www.yuque.com/yunduanxincrm/sd6oeu/sg717p')
    },
    goBack() {
      this.$router.go(-1) 
    },
    // 回显数据
    getList() {
      this.loading = true
      getLiveCard({type:this.dataForm.type,joinType:this.step}).then(res=>{
        this.loading = false
        if(res.data.id) {
          this.dataForm = {
            ...res.data,
            configTextList: this.dataForm.configTextList,
          }
          if(this.step == 0) {
            this.imageUrl1 = this.dataForm.picType==1?this.dataForm.picUrl:''
            this.picType1 = this.dataForm.picType
          }else{
            this.imageUrl2 =this.dataForm.picType==1?this.dataForm.picUrl:''
            this.picType2 = this.dataForm.picType
          }
          // 回显数据处理
          this.dataForm.configTextList.forEach((e1,i1)=>{
            res.data.configTextList.forEach((e2,i2)=>{
              if(e2.enable == 1) {
                if(!e2.useThreshold) {
                  e2.noThreshold = true
                }else{
                  e2.noThreshold = false
                }
                if(typeof(e2.levelIds) == 'string') {
                  e2.levelIds = e2.levelIds.split(',')
                }
              }else{
                e2.levelIds = []
              }
              this.$set(this.dataForm.configTextList,i2,e2)
            })
          })
        }
        if(this.dataForm.type == 2) {
          this.picType1 = 1
        }
      })
    },
    // 保存
    save() {
      let data = JSON.parse(JSON.stringify(this.dataForm))
      let obj = {
        // type: this.dataForm.type, // 小部件类型 1-0元入会招募 2-1分钱入会招募
        ...data,
        joinType: this.step,
      }
      if(this.step === 0) {
        obj.picUrl = this.imageUrl1
        obj.picType = this.picType1
        if(this.dataForm.type == 1) { // 0元入会增加判断
          if(this.dataForm.configTextList[0].denomination == 0 || !this.dataForm.configTextList[0].denomination) {
            return this.$message.error('请输入优惠券面额')
          }else if(!this.dataForm.configTextList[0].uuid) {
            return this.$message.error('请输入优惠券uuid')
          }
        }
      }else if(this.step === 1) {
        obj.picUrl = this.imageUrl2
        obj.picType = this.picType2
      }
      for(let i=obj.configTextList.length-1;i>=0;i--) {
        if(obj.configTextList[i].levelIds instanceof Array) {
          obj.configTextList[i].levelIds = obj.configTextList[i].levelIds.join(',')
        }
      }
      this.loading = true
      liveCardSave(obj).then(res=>{
        if(this.step === 0) {
          this.step = 1
          this.getList()
        }else{
          this.loading = false
          this.goBack()
        }
        this.$message.success(res.message)
      }).catch(err=>{
        this.loading = false
      })
    },
    // 上传图片
    beforeUpload1(file) {
      let _this = this;
      const isJPG = file.type === 'image/jpg';
      const isJPEG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size < 2097152;
      console.log(file)
      if (!(isJPG || isPNG || isJPEG)) {
        this.$message.error('上传图片只能是JPG和PNG格式!');
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return false
      }
      let forms = new FormData()
      forms.append("file", file);

      uploadImage(forms).then((res) => {
        if(this.step === 0) {
          this.imageUrl1 = res.data
        }else if(this.step === 1) {
          this.imageUrl2 = res.data
        }
        console.log(res,1)
      });
      return !( isJPG || isPNG || isJPEG ) && isLt2M; 
    },
  },
};
</script>

<style lang="scss" scoped>
.ipt{
  width:220px;
}
.topbox {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #000;
}
.activityManage {
  box-sizing: border-box;
  padding: 24px;
  margin: 24px;
  background: #fff;
  min-width: 1000px;
  .main{
    .main-left{
      width:400px;
      min-width: 300px;
      height: calc(100vh - 315px);
      overflow-y: auto;
      position: relative;
      .customImg{
        position: absolute;
        width: 266px;
        height: 126px;
        top: 117px;
        left: 2px;
        border-radius: 9px;
      }
    }
    .main-right{
      width: calc(100% - 400px);
      height: calc(100vh - 315px);
      min-width: 700px;
      overflow: auto;
      margin-left: 20px;
      .item-box{
        background-color: #f8f9ff;
        padding: 20px;
        margin-right: 12px;
        .item-label{
          display: inline-block;
          width: 90px;
        }

        .coupon_type {
          width: 120px;
        }
      }
    }
  }
  .bottom-btnBox{
    position: absolute;
    bottom: -30px;
    text-align: center;
    width: 100%;
    left: 0;
    background: white;
    height: 45px;
  }
}
.minTitle{
  font-weight: bold;
  border-left: 2px solid #2670FB;
  padding-left: 5px;
  font-size: 14px;
}
.imgUpload{
  display: flex;
  align-items: center;
}
.getuuid{
  cursor: pointer;
  margin-right: 3px;
}
/deep/.stepBox .el-step.is-horizontal .el-step__line{
  left:155px;
}
/deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 232px;
  height: 110px;
  line-height: 110px;
  text-align: center;
}
/deep/.avatar {
  width: 232px;
  height: 110px;
  display: block;
}
</style>
